import type { HomeStackParamList } from '../Navigator';
import { useNavigation } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';

export const useHomeNavigation = <Key extends keyof HomeStackParamList>() =>
  useNavigation<NativeStackNavigationProp<HomeStackParamList, Key>>();
